<template>
  <div class="ll-editable-question-list">
    <div class="ll-editable-question-list_title-wrap">
      <p class="question-title">
        {{ title }}
      </p>
      <WsButton001
        v-if="!isSorting"
        out-line
        medium-button
        flat-button
        @click="$_sortingStart()"
      >
        {{ $t('排序') }}
      </WsButton001>
      <div
        v-if="isSorting"
        class="save-tools"
      >
        <WsButton001
          out-line
          medium-button
          flat-button
          @click="$_sortingComplete()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          primary
          flat-button
          short-button
          @click="$_sortingSave()"
        >
          {{ $t('送出') }}
        </WsButton001>
      </div>
    </div>
    <div
      v-if="isSorting"
      class="ll-editable-question-list_list-wrap"
    >
      <div
        v-for="(list,questionListIndex) in sortingQuesItems"
        :key="questionListIndex"
        class="ll-editable-question-list_sort-list"
      >
        <p class="ll-editable-question-list_subtitle">
          {{ list.title }}
        </p>
        <div class="ll-editable-question-list_list">
          <SlickList v-model="list.questionList">
            <SlickItem
              v-for="(sortingItem,sortingIndex) in list.questionList"
              :key="sortingIndex"
              class="list-item"
              :index="sortingIndex"
            >
              <SortingChecklistQuestion
                :title="sortingItem.title"
                :ques-num="sortingIndex+1"
                :subtitle="sortingItem.subtitle"
              />
            </SlickItem>
          </SlickList>
        </div>
      </div>
    </div>
    <div
      v-else
      class="ll-editable-question-list_list-wrap"
    >
      <div
        v-for="(list,questionListIndex) in questionItems"
        :key="questionListIndex"
        class="ll-editable-question-list_list"
      >
        <p class="ll-editable-question-list_subtitle">
          {{ list.title }}
        </p>
        <div class="ll-editable-question-list_list">
          <div
            v-for="(ques,quesIndex) in list.questionList"
            :key="quesIndex"
            class="ll-editable-question-list_list-item"
          >
            <EditableChecklistQuestion002
              v-if="ques.type ==='custom'"
              :ref="`ChecklistQuestion${questionListIndex}${quesIndex}`"
              :value="list.questionList[quesIndex]"
              :ocap-edit="ocapEdit"
              :ques-num="quesIndex + 1"
              editable
              :editable-ques-type="editableQuesType"
              :text-label="textLabel"
              :attach-title="attachTitle"
              :upload-file-url="uploadAttachUrl"
              :upload-file-ocap-url="uploadFileOcapUrl"
              :chapter-num="chapterNum"
              :section-num="questionListIndex"
              :new-create="ques.newCreate"
              :radio-name="$_getRadioNameByQuestionList(radioName,questionListIndex,quesIndex)"
              :type-radio-name="$_getRadioNameByQuestionList(typeRadioName,questionListIndex,quesIndex)"
              :factory="factoryId"
              :copy-drop-down="copyDropDown"
              :effectList="effectList"
              :uploadModule="uploadModule"
              @delete="$_deleteQuesPopupOpen(list.questionList,quesIndex)"
              @copy-click="$_copyClick(ques,questionListIndex,quesIndex,`ChecklistQuestion${questionListIndex}${quesIndex}`)"
              @fetch-question="$_fetchQuestion(ques,questionListIndex,quesIndex,`ChecklistQuestion${questionListIndex}${quesIndex}`)"
              @created="$emit('created')"
              @delete-effect="$emit('delete', $event)"
              @update="$emit('update', $event)"
              @input="$_onInput($event, questionListIndex, quesIndex)"
            />
            <ChecklistQuestion002
              v-if="ques.type === 'template'"
              :ref="`ChecklistQuestion${questionListIndex}${quesIndex}`"
              select
              annex
              change-ques-type
              v-bind="ques"
              :ocap-edit="ocapEdit"
              content-icon="icon-light"
              :ques-num="quesIndex + 1"
              :text-label="textLabel"
              :radio-name="$_getRadioNameByQuestionList(radioName,questionListIndex,quesIndex)"
              :required="$_rules(ques.id)"
              :upload-file-url="uploadAttachUrl"
              :upload-file-ocap-url="uploadFileOcapUrl"
              @law-click="$_lawClick($event)"
              @input="$_focusChange($event,ques)"
              @ocap-change="$_ocapFileChange($event,ques)"
              @ocap-delete="$_ocapFileDelete($event,ques)"
              @ocap-remark="$_ocapRemark($event,ques)"
              @fetch-question="$_fetchQuestion(ques,questionListIndex,quesIndex,`ChecklistQuestion${questionListIndex}${quesIndex}`)"
            >
              <template v-slot:select>
                <StateSwitchCheckbox
                  :value="selectTemplateItems"
                  :qustion-id="ques.id ? ques.id : ques.templateId"
                  @input="$_questionSelect($event)"
                  @fetch-action="$_fetchQuestion(ques,questionListIndex,quesIndex,`ChecklistQuestion${questionListIndex}${quesIndex}`)"
                />
                <WsTextButton001
                  leading-icon="icon-copy"
                  primary
                  font-size-xs
                  no-padding
                  @click="$_copyClick(ques,questionListIndex,quesIndex,`ChecklistQuestion${questionListIndex}${quesIndex}`)"
                >
                  {{ $t('複製') }}
                </WsTextButton001>
              </template>
            </ChecklistQuestion002>
            <ChecklistQuestion002
              v-if="ques.type === 'remove'"
              nodrop-down-toggle
              remove-style
              :title="ques.title"
              :subtitle="$t('題目在此公版已移除')"
            />
          </div>
          <WsButton001 @click="$_addQuestionClick(questionListIndex)">
            {{ $t('新增自訂題目') }}
          </WsButton001>
        </div>
      </div>
    </div>
    <PopUp
      :pop-up-active="active.deleteQuesPopup"
      :title="$t('確定捨棄嗎？')"
      @click="$_deleteQuesPopupClose()"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001
            out-line
            @click="$_deleteQuesPopupClose()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_deleteQuestion(deleteQuesItems, indexDeleteQues)">
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
    <LlActPopup
      v-if="lawPopupActive"
      :is-loading="isLawContentLoading"
      :law-content="lawContent"
      :popup-active="lawPopupActive"
      @popup-close="$_lawPopupClose()"
    />
    <LlActPopup
      v-else
      :popup-active="lawPopupActive"
      @popup-close="$_lawPopupClose()"
    />
  </div>
</template>
<script>
import { SlickList, SlickItem } from "vue-slicksort";
import H_common from "@/helpers/common";
export default {
  name: "LlEditableQuestionList002",
  components: {
    SlickList,
    SlickItem,
  },
  props: {
    isLawContentLoading: {
      type: Boolean,
    },
    ocapEdit: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    editableQuesType: {
      type: Boolean,
    },
    selectTemplateItems: {
      type: Array,
      default() {
        return [];
      },
    },
    questionItems: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadImageUrl: {
      type: String,
    },
    uploadAttachUrl: {
      type: String,
    },
    uploadFileOcapUrl: {
      type: String,
    },
    factoryId: {
      type: String,
    },
    chapterNum: {
      type: Number,
    },
    isMtSm: {
      type: Boolean,
    },
    textLabel: {
      type: String,
      default() {
        return this.$t("合規標準");
      },
    },
    attachTitle: {
      type: String,
      default() {
        return this.$t("附件");
      },
    },
    radioName: {
      type: String,
    },
    typeRadioName: {
      type: String,
    },
    lawContent: {
      type: Object,
      default() {
        return {};
      },
    },
    copyDropDown: {
      type: Boolean,
    },
    fetchQuesFunc: {
      //fetch question content api
      type: Function,
    },
    effectList: {
      type: Array,
    },
    uploadModule: {
      type: String,
    },
  },
  data: () => ({
    isSorting: false,
    sortingQuesItems: [],
    lawPopupActive: false,
    deleteQuesItems: [],
    indexDeleteQues: 0,
    active: {
      deleteQuesPopup: false,
    },
  }),
  watch: {
    isSorting: {
      deep: true,
      handler() {
        this.$emit("sorting-active", this.isSorting);
      },
    },
  },
  methods: {
    $_rules(questionId) {
      if (!this.selectTemplateItems.includes(questionId)) {
        return false;
      } else {
        return true;
      }
    },
    $_getRadioNameByQuestionList(radioName, questionListIndex, quesIndex) {
      return `${radioName}-${questionListIndex}-${quesIndex}`;
    },
    $_focusChange($event, ques) {
      ques.focus = $event;
      this.$emit("focus-change", $event);
    },
    $_ocapFileChange($event, ques) {
      ques.ocapAttaches = $event;
    },
    $_ocapFileDelete(index, ques) {
      ques.ocapAttaches.splice(index, 1);
    },
    $_ocapRemark($event, ques) {
      ques.ocapRemark = $event;
    },
    $_deleteQuesPopupOpen(questionList, index) {
      this.active.deleteQuesPopup = true;
      this.deleteQuesItems = questionList;
      this.indexDeleteQues = index;
    },
    $_deleteQuesPopupClose() {
      this.active.deleteQuesPopup = false;
      this.deleteQuesItems = [];
      this.indexDeleteQues = 0;
    },
    $_lawClick($event) {
      this.lawPopupActive = true;
      this.$emit("law-click", $event);
    },
    $_lawPopupClose() {
      this.lawPopupActive = false;
    },
    $_sortingStart() {
      this.isSorting = true;
      this.sortingQuesItems = [...this.questionItems];
    },
    $_sortingSave() {
      this.$emit("question-edit", this.sortingQuesItems);
      this.$_sortingComplete();
    },
    $_sortingComplete() {
      this.isSorting = false;
    },
    $_deleteQuestion(questionList, index) {
      questionList.splice(index, 1);
      this.$emit("delete-click", questionList);
      this.$_deleteQuesPopupClose();
    },
    $_addQuestionClick($event) {
      this.$emit("add-click", $event);
    },
    async $_copyClick(ques, listIndex, quesIndex, ref) {
      //公版題目 id、複製的公版題目、自訂題目id or no id、複製的自訂題目
      if (!ques.hasFetch) {
        //有id，但沒有抓過題目內容，要先抓題目內容再複製
        await this.$_fetchQuestion(ques, listIndex, quesIndex, ref);
      }
      //有id，已抓過題目內容，直接複製
      //無id，直接複製
      const copyQuesList = H_common.deepCopyFunction(this.questionItems[listIndex].questionList)
      const copyQues = H_common.deepCopyFunction(this.questionItems[listIndex].questionList[quesIndex])
      copyQues.title = `${copyQues.title}-${this.$t("複製")}`;
      if (!copyQues.attaches) {
        copyQues.attaches = [];
      }
      copyQuesList.push({
        ...copyQues,
        id: null,
        type: "custom",
        subtitle: this.$t("自訂題目"),
      });
      this.$emit("copy-ques", {listIndex, questionList: copyQuesList})
    },
    $_questionSelect($event) {
      this.$emit("question-select", $event);
    },
    async $_submitClick() {
      if (this.$refs.EditableChecklistQuestion) {
        for (let i = 0; i < this.$refs.EditableChecklistQuestion.length; i++) {
          await this.$refs.EditableChecklistQuestion[i].$_submitClick();
        }
      }
      if (this.$refs.ChecklistQuestion) {
        for (let i = 0; i < this.$refs.ChecklistQuestion.length; i++) {
          await this.$refs.ChecklistQuestion[i].$_submitClick();
        }
      }
    },
    async $_fetchQuestion(ques, listIndex, quesIndex, ref) {
      if (
        (ques.type === "custom" && !ques.versionId)
        || !this.fetchQuesFunc
        || ques.hasFetch
      ) return;
      if (ref) {
        this.$refs[ref][0].$_loadingStart();
      }
      const version = await this.fetchQuesFunc(ques);
      await this.$set(this.questionItems[listIndex].questionList, quesIndex, {
        ...ques,
        ...version,
        hasFetch: true,
        id: ques.id,
      });
      if (ref) {
        this.$refs[ref][0].$_loadingEnd();
      }
    },
    $_onInput($event, questionListIndex, quesIndex) {
      const {key, value} = $event;
      this.$emit('input', {key, value, questionListIndex, quesIndex});
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-editable-question-list";
</style>